import {Controller} from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";
import {Modal} from "bootstrap";
import {emptyFilter, Filter} from "./filter";

export default class extends Controller {
    static targets = ["form", "checkbox", "input"];

    declare readonly formTarget: HTMLFormElement;
    declare readonly checkboxTargets: HTMLInputElement[];
    declare readonly inputTargets: HTMLInputElement[];

    private modalElement: Modal | null = null;

    private initialState = emptyFilter();

    connect() {
        console.log('Filter modal controller connected');
        this.modalElement = new bootstrap.Modal(
            this.element, {
                backdrop: 'static',
                keyboard: false
            });

        this.element.addEventListener('hidePrevented.bs.modal', this.close.bind(this));
        document.addEventListener("map-sidebar-filter-changed", this.syncState as EventListener);
    }

    disconnect() {
        this.modalElement?.dispose();
    }

    open() {
        this.initialState = this.buildState();

        console.log(`Initial state: ${JSON.stringify(this.initialState)}`);

        this.modalElement?.show();
    }

    close() {
        this.modalElement?.hide();
        this.applyState(this.initialState);
    }

    apply() {
        const filterValues = emptyFilter();

        this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => {
            if (!filterValues.checkboxes[checkbox.name]) {
                filterValues.checkboxes[checkbox.name] = [];
            }

            (filterValues.checkboxes[checkbox.name]).push(checkbox.value);
        });

        this.inputTargets.filter(input => input.value).map(input => {
            filterValues.inputs[input.name] = input.value;
        });

        this.element.dispatchEvent(
            new CustomEvent("list-modal-filter-changed", {detail: filterValues, bubbles: true})
        );

        this.formTarget.requestSubmit();
    }

    private buildState = (): Filter => {
        const state = emptyFilter();

        this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => {
            if (!state.checkboxes[checkbox.name]) {
                state.checkboxes[checkbox.name] = [];
            }

            (state.checkboxes[checkbox.name]).push(checkbox.value);
        });

        this.inputTargets.filter(input => input.value).map(input => {
            state.inputs[input.name] = input.value;
        });

        return state;
    }

    private applyState = (state: Filter): void => {
        this.checkboxTargets.forEach(checkbox => {
            checkbox.checked = !!state.checkboxes[checkbox.name]?.includes(checkbox.value);
        });

        this.inputTargets.forEach(input => {
            input.value = state.inputs[input.name] || "";
        });
    }

    syncState = (
        event: CustomEvent<Filter>
    ): void => {
        console.log('Modal: sync sidebar state');

        this.applyState(event.detail);
    }
}